import { render, staticRenderFns } from "./ShiftReport.vue?vue&type=template&id=4ffe8d6c&"
import script from "./ShiftReport.vue?vue&type=script&lang=js&"
export * from "./ShiftReport.vue?vue&type=script&lang=js&"
import style0 from "./ShiftReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports